import React from 'react'
import Detail from '../Fav/Detail'
import Nav from '../Nav'
import Footer from '../Footer'

function About() {
    return (
        <>
            <Nav />
            <Detail />
            <Footer/>
        </>
    )
}

export default About